"use client";

import { PosthogPageview } from "@/ui/layout/posthog-pageview";
import { Analytics as PqzAnalytics } from "@panda0/analytics/react";
import {
  KeyboardShortcutProvider,
  TooltipProvider,
  useRemoveGAParams,
} from "@panda0/panda0-ui";
import PlausibleProvider from "next-plausible";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { ReactNode } from "react";
import { Toaster } from "sonner";

if (typeof window !== "undefined") {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
    api_host: "https://us.i.posthog.com",
    person_profiles: "identified_only",
    disable_session_recording: false,
    capture_pageview: false, // Disable automatic pageview capture, as we capture manually
    capture_pageleave: true, // Enable pageleave capture
    persistence: 'localStorage',
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        password: true,
      },
    },
  });
}

export default function RootProviders({ children }: { children: ReactNode }) {
  useRemoveGAParams();

  return (
    <PostHogProvider client={posthog}>
      <PlausibleProvider
        domain="hirepanda.com"
        revenue
      />
      <TooltipProvider>
        <KeyboardShortcutProvider>
          <Toaster closeButton className="pointer-events-auto" />
          <PosthogPageview />
          {children}
          <PqzAnalytics
            apiHost="/_proxy/hirepanda"
            shortDomain="refer.hirepanda.com"
            cookieOptions={{
              domain: ".hirepanda.com",
            }}
          />
        </KeyboardShortcutProvider>
      </TooltipProvider>
    </PostHogProvider>
  );
}
